export default __webpack_public_path__ + "static/ogg-image-default-4fd11c735316dd678e7a7e08515cd339.png";